import React from 'react'
import Layout from './Layout'
import { Link } from 'react-router-dom'

export default function Maths() {
  return (
    <Layout page={<div>
      <h1>Maths</h1>
      <h3>Module 1</h3>
      <ul>
        <Link to='/file/maths/Differential Calculus -1 Part 1.pdf'>Differential Calculus -1 Part 1.pdf</Link>
        <Link to='/file/maths/Differential Calculus- 1 Part 2.pdf'>Differential Calculus- 1 Part 2.pdf</Link>
      </ul>
      <h3>Module 2</h3>
      <ul>
        <Link to='/file/maths/Module-2 part-1.pdf'>Module-2 part-1.pdf</Link>
        <Link to='/file/maths/Partial derivatives.pdf'>Partial derivatives.pdf</Link>
        <Link to='/file/maths/Maxima minima.pdf'>Maxima minima.pdf</Link>
      </ul>
      <h3>Module 3</h3>
      <ul>
        <Link to="/file/maths/1st order DE Till Bernoulli's eqn.pdf">1st order DE Till Bernoulli's eqn.pdf</Link>
        <Link to='/file/maths/NLC-LR and non Linear.pdf'>NLC-LR and non Linear.pdf</Link>
        <Link to='/file/maths/Applications of BE and Orthogonal trajectories..pdf'>Applications of BE and Orthogonal trajectories..pdf</Link>
      </ul>
      <h3>Module 4</h3>
      <ul>
        <Link to='/file/maths/Higher Order DE Part-1.pdf'>Higher Order DE Part-1.pdf</Link>
        <Link to='/file/maths/Higher Order DE Part-2.pdf'>Higher Order DE Part-2.pdf</Link>
        <Link to='/file/maths/Higher order DE- part-3.pdf'>Higher order DE- part-3.pdf</Link>
      </ul>
      <h3>Module 5</h3>
      <ul>
        <Link to='/file/maths/Module-V_Linear Algebra-1.pdf'>Module-V_Linear Algebra-1.pdf</Link>
        <Link to='/file/maths/Modul-V_Linear Algebra-2.pdf'>Modul-V_Linear Algebra-2.pdf</Link>
      </ul>
    </div>} />
  )
}
